// libs
import { useState } from "react";
import { PlaySquare } from "lucide-react";

// components
import CustomButton from "../../components/CustomButton";
import ActionsPanel from "../../components/ActionsPanel";
import Actions from "../../components/Actions";
import NoAccess from "../../components/NoAccess";

// hooks
import useUserData from "../../hooks/useUserData";

// styles
import classes from "./styles.module.css";

export default function ActionsPage() {
  const [isFirstTab, setIsFirstTab] = useState(true);
  const { isAdmin } = useUserData();

  const setFirstTab = () => setIsFirstTab(true);
  const setSecondTab = () => setIsFirstTab(false);

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <div className={classes.headText}>
          <PlaySquare stroke="#009966" />
          <p>Проводка по кассе</p>
        </div>
      </div>

      {isAdmin ? (
        <div className={classes.content}>
          <div className={classes.tabChecker}>
            <CustomButton
              onClick={setFirstTab}
              className={`${classes.tabButton} ${isFirstTab && classes.tabButtonActive}`}
            >
              Оформить
            </CustomButton>
            <CustomButton
              onClick={setSecondTab}
              className={`${classes.tabButton} ${!isFirstTab && classes.tabButtonActive}`}
            >
              История
            </CustomButton>
          </div>

          {isFirstTab ? <ActionsPanel /> : <Actions />}
        </div>
      ) : (
        <NoAccess />
      )}
    </div>
  );
}
